import React from "react";
import PropTypes from "prop-types";
import TableCell from "@material-ui/core/TableCell";

const TableIconCell = ({ children, style, ...props }) => (
  <TableCell
    {...props}
    style={{
      ...style,
      textAlign: "right",
      whiteSpace: "nowrap",
    }}
  >
    {children}
  </TableCell>
);

TableIconCell.propTypes = {
  /**
   * Estilos del componente
   */
  style: PropTypes.object,
};

export default TableIconCell;
